import { render, staticRenderFns } from "./DemoLayout.vue?vue&type=template&id=f9ce9f6a&"
import script from "./DemoLayout.vue?vue&type=script&lang=js&"
export * from "./DemoLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports